<template>
  <div>

    <form @submit.prevent="findClub">
      <div class="form-group">
        <label for="search-type-selector">Search type</label>
        <select v-model="searchType" id="search-type-selector" class="form-control">
          <option :value="SEARCH_TYPE_ID">Search by ID</option>
          <option :value="SEARCH_TYPE_NAME">Search by name</option>
        </select>
      </div>
      <div class="form-group">
        <label for="identity-value">{{identityName}}</label>
        <input v-model="identityValue" id="identity-value" class="form-control" required>
      </div>
      <b-button type="submit" variant="primary">Find</b-button>
    </form>

    <div v-show="foundClubs !== null" class="result">
      <h3>Search results</h3>

      <p v-show="resultMessage !== null">
        {{resultMessage}}
      </p>

      <table v-if="isDataLoaded && foundClubs.length > 0" class="table">
        <thead class="thead-dark">
          <tr>
            <th scope="col">Name</th>
            <th scope="col">Club</th>
          </tr>
        </thead>
        <tr
          v-for="club in foundClubs"
          :key="club.id"
        >
          <td>
            {{club.name}}
          </td>
          <td>
            <club-link :clubId="club.id" />
          </td>
        </tr>
      </table>
    </div>

  </div>
</template>

<script>
import { HTTP } from '../http-common';
import notifier from '../notifier';
import ClubLink from './ClubLink.vue';

const SEARCH_TYPE_ID   = 0;
const SEARCH_TYPE_NAME = 1;

export default {
  name: 'ClubSearch',

  components: {
    ClubLink,
  },

  data() {
    return {
      SEARCH_TYPE_ID,
      SEARCH_TYPE_NAME,

      searchType: SEARCH_TYPE_ID,
      identityValue: '',

      foundClubs: null,
    };
  },

  computed: {
    isDataLoaded() {
      return this.foundClubs !== null;
    },

    identityName() {
      switch(this.searchType) {
        case SEARCH_TYPE_ID:   return 'Club ID';
        case SEARCH_TYPE_NAME: return 'Club name';
        default:
          return `Unknown search type (${this.searchType})`;
      }
    },

    resultMessage() {
      if(this.foundClubs !== null && this.foundClubs.length === 0) {
        return 'Clubs not found.';
      }
      return null;
    },
  },

  watch: {
    searchType() {
      this.resetSearchResults();
    },
    identityValue() {
      this.resetSearchResults();
    },
  },

  methods: {
    findClub() {
      notifier.deleteSenderNotifications(this);

      switch(this.searchType) {
        case SEARCH_TYPE_ID:
          this.findClubById();
          break;

        case SEARCH_TYPE_NAME:
          this.findClubByName();
          break;

        default:
          notifier.showError(
            `Can not find club. Unknown search type (${this.searchType})`,
            {sender: this}
          );
      }
    },

    findClubById() {
      const clubIdStr = this.identityValue.trim();
      const clubId = parseInt(clubIdStr, 10);
      if(isNaN(clubId)) {
        notifier.showError(
          'Club id must be an integer.',
          {sender: this}
        );
        return;
      }

      const url = `/club/${clubId}/check_existence`;
      HTTP.get(url)
      .then(response => {
        const data = response.data.data;
        if(!('club_exists' in data)) {
          notifier.showError(`Invalid server response. Property club_exists not found.`, {sender: this});
          return;
        }

        if(data.club_exists) {
          this.$router.push({name: 'club_info', params: {clubId: clubId}});
          return;
        }

        // Club with specified id does not exist.
        this.foundClubs = [];
      })
      .catch(error => {
        notifier.showError(error.response.data);
      });
    },

    findClubByName() {
      const q = this.identityValue.trim();

      HTTP.get(
        '/club/find_by_name',
        {
          params: {
            q,
          }
        }
      )
      .then(response => {
        this.foundClubs = response.data.data;
      })
      .catch(e => {
        notifier.showError(e.response.data);
      });
    },

    resetSearchResults() {
      this.foundClubs = null;
    },
  },
};
</script>

<style scoped>
.result {
  margin-top: 2rem;
}

.table {
  white-space: nowrap;
}
</style>
